import { useState, useRef, useEffect } from "react";
import MyStudentLayout from "../../../layouts/Student/MyStudentLayout";
import "./../../../assets/css/student/ChatList.css";

// ─── SVG ICONS ────────────────────────────────────────────────────────────────
const Icon = {
  Search: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="1.8"/>
      <path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  ),
  Send: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M22 2L11 13" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M22 2L15 22l-4-9-9-4 20-7z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  Attach: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  Star: () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
    </svg>
  ),
  Circle: ({ fill }) => (
    <svg width="8" height="8" viewBox="0 0 8 8">
      <circle cx="4" cy="4" r="4" fill={fill}/>
    </svg>
  ),
  ChevronDown: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
      <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  Code: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
      <polyline points="16 18 22 12 16 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
      <polyline points="8 6 2 12 8 18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  Shield: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  Book: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
      <path d="M4 19.5A2.5 2.5 0 016.5 17H20" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  ),
  Map: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
      <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="8" y1="2" x2="8" y2="18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
      <line x1="16" y1="6" x2="16" y2="22" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  ),
  Calendar: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
      <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="1.8"/>
      <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
      <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
      <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" strokeWidth="1.8"/>
    </svg>
  ),
  Alert: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
      <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="12" y1="9" x2="12" y2="13" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
      <line x1="12" y1="17" x2="12.01" y2="17" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
    </svg>
  ),
  Flag: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
      <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="4" y1="22" x2="4" y2="15" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  ),
  Close: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
      <line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  ),
  Filter: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
      <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  Headset: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M3 18v-6a9 9 0 0118 0v6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
      <path d="M21 19a2 2 0 01-2 2h-1a2 2 0 01-2-2v-3a2 2 0 012-2h3v5z" stroke="currentColor" strokeWidth="1.8"/>
      <path d="M3 19a2 2 0 002 2h1a2 2 0 002-2v-3a2 2 0 00-2-2H3v5z" stroke="currentColor" strokeWidth="1.8"/>
    </svg>
  ),
  Check: () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
      <polyline points="20 6 9 17 4 12" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  Dots: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="1.5" fill="currentColor"/>
      <circle cx="19" cy="12" r="1.5" fill="currentColor"/>
      <circle cx="5" cy="12" r="1.5" fill="currentColor"/>
    </svg>
  ),
};

// ─── MOCK DATA ────────────────────────────────────────────────────────────────
const CONVERSATIONS = [
  {
    id: 1,
    type: "mentor",
    name: "Sarah Chen",
    initials: "SC",
    color: "#7C3AED",
    role: "Senior Frontend Engineer",
    status: "online",
    lastMessage: "Great question! Let me show you how React hooks work in this context.",
    time: "2m ago",
    unread: 2,
    course: "Advanced React Patterns",
    skills: ["React", "TypeScript", "Hooks", "Performance"],
    rating: 4.9,
    messages: [
      { id: 1, from: "mentor", text: "Hey! Ready to dive into React hooks today?", time: "10:00 AM" },
      { id: 2, from: "student", text: "Yes! I'm struggling with useEffect and the dependency array.", time: "10:02 AM" },
      { id: 3, from: "mentor", text: "That's one of the most common pain points. Let me explain with a real example.", time: "10:03 AM" },
      { id: 4, from: "mentor", text: "Here's the key rule: put everything you use inside useEffect that might change over time into the dependency array.", time: "10:04 AM", isCode: false },
      { id: 5, from: "mentor", text: "useEffect(() => {\n  fetchData(userId); // userId must be in deps\n}, [userId]); // correct!", time: "10:05 AM", isCode: true },
      { id: 6, from: "student", text: "Ohh that makes so much more sense! What about when I get the infinite loop?", time: "10:07 AM" },
      { id: 7, from: "mentor", text: "Great question! Let me show you how React hooks work in this context.", time: "10:08 AM" },
    ],
  },
  {
    id: 2,
    type: "mentor",
    name: "Marcus Rivera",
    initials: "MR",
    color: "#059669",
    role: "ML Engineer @ Google DeepMind",
    status: "offline",
    lastMessage: "I've attached some resources on neural networks for you.",
    time: "1h ago",
    unread: 0,
    course: "Machine Learning Foundations",
    skills: ["Python", "TensorFlow", "Data Science", "LLMs"],
    rating: 4.8,
    messages: [
      { id: 1, from: "mentor", text: "Welcome! I see you're enrolled in ML Foundations. Where are you in the course?", time: "9:00 AM" },
      { id: 2, from: "student", text: "I just finished the linear regression module. Neural networks feel intimidating.", time: "9:05 AM" },
      { id: 3, from: "mentor", text: "Totally normal feeling. Think of neural networks as layers of simple decisions stacked together.", time: "9:08 AM" },
      { id: 4, from: "mentor", text: "I've attached some resources on neural networks for you.", time: "9:10 AM" },
    ],
  },
  {
    id: 3,
    type: "mentor",
    name: "Priya Nair",
    initials: "PN",
    color: "#D97706",
    role: "Staff Backend Engineer @ Notion",
    status: "online",
    lastMessage: "Your API design is solid. Just consider rate limiting.",
    time: "Yesterday",
    unread: 1,
    course: "Backend Architecture",
    skills: ["Node.js", "PostgreSQL", "API Design", "System Design"],
    rating: 4.7,
    messages: [
      { id: 1, from: "student", text: "I designed my first REST API! Can you review it?", time: "Yesterday, 3:00 PM" },
      { id: 2, from: "mentor", text: "Sure! Share the endpoint structure.", time: "Yesterday, 3:15 PM" },
      { id: 3, from: "student", text: "POST /users, GET /users/:id, PUT /users/:id, DELETE /users/:id", time: "Yesterday, 3:17 PM" },
      { id: 4, from: "mentor", text: "Your API design is solid. Just consider rate limiting.", time: "Yesterday, 3:20 PM" },
    ],
  },
  {
    id: "admin",
    type: "admin",
    name: "Support Team",
    initials: "ST",
    color: "#DC2626",
    role: "Tech Mentor Hub Support",
    status: "online",
    lastMessage: "Your payment issue has been escalated to our billing team.",
    time: "3h ago",
    unread: 1,
    issueType: "Payment Issue",
    issueStatus: "In Progress",
    priority: "High",
    messages: [
      { id: 1, from: "admin", text: "Hello! I'm from the Tech Mentor Hub support team. How can I help you today?", time: "8:00 AM", isSystem: false },
      { id: 2, from: "student", text: "Issue: Payment Failure\n\nI was charged twice for my subscription this month.", time: "8:02 AM", isSystem: true },
      { id: 3, from: "admin", text: "I'm sorry to hear that. Let me look into your account right away.", time: "8:05 AM" },
      { id: 4, from: "admin", text: "I can see the duplicate charge. I've flagged this for our billing team and you'll receive a refund within 3-5 business days.", time: "8:10 AM" },
      { id: 5, from: "student", text: "Thank you! Will I get a confirmation email?", time: "8:12 AM" },
      { id: 6, from: "admin", text: "Your payment issue has been escalated to our billing team.", time: "8:15 AM" },
    ],
  },
];

const ISSUE_TYPES = [
  { id: "payment", label: "Payment Issue", icon: "alert", color: "#DC2626", desc: "Billing, refunds, subscription" },
  { id: "mentor", label: "Mentor Issue", icon: "flag", color: "#D97706", desc: "Misconduct, no-shows, disputes" },
  { id: "technical", label: "Technical Bug", icon: "code", color: "#2563EB", desc: "Platform errors, login issues" },
  { id: "other", label: "Other", icon: "shield", color: "#7C3AED", desc: "General queries & feedback" },
];

const SUGGESTED_MENTORS = [
  { id: 4, name: "James Liu", initials: "JL", color: "#DC2626", role: "Engineering Manager", skills: ["Interview Prep", "Leadership"] },
  { id: 5, name: "Aisha Johnson", initials: "AJ", color: "#0891B2", role: "DevRel Lead @ Vercel", skills: ["Next.js", "Portfolio"] },
];

// ─── HELPERS ──────────────────────────────────────────────────────────────────
function Avatar({ initials, color, size = 40, online }) {
  return (
    <div className="ch-avatar" style={{ width: size, height: size, background: `${color}18`, color, borderColor: `${color}25`, fontSize: size * 0.34 }}>
      {initials}
      {online !== undefined && (
        <span className={`ch-av-dot ${online ? "dot-on" : "dot-off"}`} />
      )}
    </div>
  );
}

function TypingIndicator() {
  return (
    <div className="ch-typing">
      <span /><span /><span />
    </div>
  );
}

// ─── ISSUE SELECTOR MODAL ────────────────────────────────────────────────────
function IssueSelector({ onSelect, onClose }) {
  return (
    <div className="ch-issue-overlay" onClick={onClose}>
      <div className="ch-issue-modal" onClick={e => e.stopPropagation()}>
        <div className="ch-issue-header">
          <div className="ch-issue-title">
            <Icon.Headset />
            Contact Support
          </div>
          <button className="ch-icon-btn" onClick={onClose}><Icon.Close /></button>
        </div>
        <p className="ch-issue-subtitle">Select the type of issue you're experiencing</p>
        <div className="ch-issue-grid">
          {ISSUE_TYPES.map(issue => (
            <button key={issue.id} className="ch-issue-card" onClick={() => onSelect(issue)} style={{ "--ic": issue.color }}>
              <div className="ch-ic-icon" style={{ background: `${issue.color}12`, color: issue.color }}>
                {issue.icon === "alert" && <Icon.Alert />}
                {issue.icon === "flag" && <Icon.Flag />}
                {issue.icon === "code" && <Icon.Code />}
                {issue.icon === "shield" && <Icon.Shield />}
              </div>
              <div className="ch-ic-label">{issue.label}</div>
              <div className="ch-ic-desc">{issue.desc}</div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

// ─── LEFT PANEL ───────────────────────────────────────────────────────────────
function LeftPanel({ conversations, activeId, onSelect, onNewSupport, search, setSearch, filter, setFilter }) {
  const filtered = conversations.filter(c => {
    const q = search.toLowerCase();
    const matchSearch = !q || c.name.toLowerCase().includes(q) ||
      (c.skills || []).some(s => s.toLowerCase().includes(q));
    const matchFilter = filter === "all" || c.type === filter ||
      (filter === "unread" && c.unread > 0);
    return matchSearch && matchFilter;
  });

  const suggested = search
    ? SUGGESTED_MENTORS.filter(m =>
        m.name.toLowerCase().includes(search.toLowerCase()) ||
        m.skills.some(s => s.toLowerCase().includes(search.toLowerCase()))
      )
    : [];

  return (
    <div className="ch-left">
      <div className="ch-left-head">
        <div className="ch-left-title">Messages</div>
        <button className="ch-support-pill" onClick={onNewSupport}>
          <Icon.Headset />
          Support
        </button>
      </div>

      <div className="ch-search-wrap">
        <span className="ch-search-icon"><Icon.Search /></span>
        <input
          className="ch-search"
          placeholder="Search mentors or chats..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>

      <div className="ch-filters">
        {["all", "mentor", "admin", "unread"].map(f => (
          <button key={f} className={`ch-filter-btn ${filter === f ? "ch-filter-active" : ""}`} onClick={() => setFilter(f)}>
            {f === "all" ? "All" : f === "admin" ? "Support" : f.charAt(0).toUpperCase() + f.slice(1)}
          </button>
        ))}
      </div>

      <div className="ch-conv-list">
        {filtered.map(c => (
          <button
            key={c.id}
            className={`ch-conv-item ${activeId === c.id ? "ch-conv-active" : ""} ${c.type === "admin" ? "ch-conv-admin" : ""}`}
            onClick={() => onSelect(c.id)}
          >
            <div className="ch-conv-av">
              <Avatar initials={c.initials} color={c.color} size={42} online={c.status === "online"} />
            </div>
            <div className="ch-conv-body">
              <div className="ch-conv-top">
                <span className="ch-conv-name">{c.name}</span>
                <span className="ch-conv-time">{c.time}</span>
              </div>
              <div className="ch-conv-bottom">
                <span className="ch-conv-preview">{c.lastMessage}</span>
                {c.unread > 0 && <span className="ch-unread">{c.unread}</span>}
              </div>
              {c.type === "admin" && <span className="ch-admin-tag">Support</span>}
            </div>
          </button>
        ))}

        {suggested.length > 0 && (
          <>
            <div className="ch-section-label">Suggested Mentors</div>
            {suggested.map(m => (
              <button key={m.id} className="ch-conv-item ch-conv-suggested">
                <Avatar initials={m.initials} color={m.color} size={42} />
                <div className="ch-conv-body">
                  <div className="ch-conv-top">
                    <span className="ch-conv-name">{m.name}</span>
                    <span className="ch-new-tag">New</span>
                  </div>
                  <div className="ch-conv-preview">{m.skills.join(", ")}</div>
                </div>
              </button>
            ))}
          </>
        )}

        {filtered.length === 0 && suggested.length === 0 && (
          <div className="ch-empty-list">No conversations found</div>
        )}
      </div>
    </div>
  );
}

// ─── CENTER PANEL ─────────────────────────────────────────────────────────────
function CenterPanel({ convo, onSend, showTyping }) {
  const [input, setInput] = useState("");
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [convo?.messages, showTyping]);

  if (!convo) {
    return (
      <div className="ch-center ch-center-empty">
        <div className="ch-empty-state">
          <div className="ch-empty-icon"><Icon.Search /></div>
          <div className="ch-empty-title">Select a conversation</div>
          <div className="ch-empty-sub">Choose a mentor or support chat from the left panel</div>
        </div>
      </div>
    );
  }

  const handleSend = () => {
    if (!input.trim()) return;
    onSend(input.trim());
    setInput("");
  };

  const handleKey = e => {
    if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); handleSend(); }
  };

  return (
    <div className="ch-center">
      {/* Header */}
      <div className="ch-center-head">
        <div className="ch-head-left">
          <Avatar initials={convo.initials} color={convo.color} size={38} online={convo.status === "online"} />
          <div>
            <div className="ch-head-name">{convo.name}</div>
            <div className={`ch-head-status ${convo.status === "online" ? "status-on" : "status-off"}`}>
              <Icon.Circle fill={convo.status === "online" ? "#22c55e" : "#94a3b8"} />
              {convo.status === "online" ? "Online" : "Offline"}
              {convo.type === "mentor" && ` · ${convo.course}`}
            </div>
          </div>
        </div>
        <div className="ch-head-right">
          {convo.type === "admin" && (
            <span className={`ch-priority-badge priority-${convo.priority?.toLowerCase()}`}>
              <Icon.Alert /> {convo.priority} Priority
            </span>
          )}
          <button className="ch-icon-btn"><Icon.Dots /></button>
        </div>
      </div>

      {/* Messages */}
      <div className="ch-messages">
        {convo.type === "mentor" && (
          <div className="ch-smart-suggest">
            <Icon.Book />
            <span>Ask about your current assignment in <strong>{convo.course}</strong></span>
          </div>
        )}

        {convo.messages.map(msg => (
          <div key={msg.id} className={`ch-msg-row ${msg.from === "student" ? "ch-msg-right" : "ch-msg-left"}`}>
            {msg.from !== "student" && (
              <Avatar initials={convo.initials} color={convo.color} size={30} />
            )}
            <div className="ch-msg-group">
              {msg.isSystem ? (
                <div className="ch-system-bubble">
                  <Icon.Flag />
                  {msg.text}
                </div>
              ) : msg.isCode ? (
                <div className="ch-code-bubble">
                  <div className="ch-code-bar"><Icon.Code /> code</div>
                  <pre>{msg.text}</pre>
                </div>
              ) : (
                <div className={`ch-bubble ${msg.from === "student" ? "ch-bubble-student" : "ch-bubble-mentor"} ${convo.type === "admin" ? "ch-bubble-admin" : ""}`}>
                  {msg.text}
                </div>
              )}
              <div className="ch-msg-time">{msg.time}</div>
            </div>
          </div>
        ))}

        {showTyping && (
          <div className="ch-msg-row ch-msg-left">
            <Avatar initials={convo.initials} color={convo.color} size={30} />
            <div className="ch-msg-group">
              <TypingIndicator />
            </div>
          </div>
        )}

        <div ref={bottomRef} />
      </div>

      {/* Input */}
      <div className="ch-input-area">
        <button className="ch-attach-btn"><Icon.Attach /></button>
        <textarea
          className="ch-input"
          placeholder={convo.type === "admin" ? "Describe your issue..." : "Ask your mentor anything..."}
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={handleKey}
          rows={1}
        />
        <button className={`ch-send-btn ${input.trim() ? "ch-send-active" : ""}`} onClick={handleSend}>
          <Icon.Send />
        </button>
      </div>
    </div>
  );
}

// ─── RIGHT PANEL ──────────────────────────────────────────────────────────────
function RightPanel({ convo }) {
  if (!convo) return <div className="ch-right ch-right-empty" />;

  if (convo.type === "admin") {
    return (
      <div className="ch-right">
        <div className="ch-right-title">Issue Details</div>

        <div className="ch-right-card ch-right-card-admin">
          <Avatar initials={convo.initials} color={convo.color} size={52} online={convo.status === "online"} />
          <div className="ch-right-name">{convo.name}</div>
          <div className="ch-right-role">{convo.role}</div>
        </div>

        <div className="ch-detail-block">
          <div className="ch-detail-label">Issue Type</div>
          <div className="ch-detail-value ch-issue-type-val">
            <Icon.Alert />
            {convo.issueType}
          </div>
        </div>

        <div className="ch-detail-block">
          <div className="ch-detail-label">Status</div>
          <div className={`ch-status-pill status-pill-${convo.issueStatus?.toLowerCase().replace(" ", "-")}`}>
            <span className="ch-status-dot" />
            {convo.issueStatus}
          </div>
        </div>

        <div className="ch-detail-block">
          <div className="ch-detail-label">Priority</div>
          <div className={`ch-priority-pill priority-pill-${convo.priority?.toLowerCase()}`}>
            {convo.priority}
          </div>
        </div>

        <div className="ch-right-divider" />

        <div className="ch-detail-label" style={{ marginBottom: 10 }}>Quick Actions</div>
        <button className="ch-action-btn ch-action-secondary">
          <Icon.Flag /> Escalate Issue
        </button>
        <button className="ch-action-btn ch-action-ghost">
          <Icon.Check /> Mark Resolved
        </button>
      </div>
    );
  }

  return (
    <div className="ch-right">
      <div className="ch-right-title">Mentor Info</div>

      <div className="ch-right-card">
        <Avatar initials={convo.initials} color={convo.color} size={56} online={convo.status === "online"} />
        <div className="ch-right-name">{convo.name}</div>
        <div className="ch-right-role">{convo.role}</div>
        <div className="ch-right-rating">
          <Icon.Star />
          <span>{convo.rating}</span>
          <span className="ch-rating-label">rating</span>
        </div>
      </div>

      <div className="ch-detail-block">
        <div className="ch-detail-label">Current Course</div>
        <div className="ch-course-pill">
          <Icon.Book />
          {convo.course}
        </div>
      </div>

      <div className="ch-detail-block">
        <div className="ch-detail-label">Skills</div>
        <div className="ch-skills-wrap">
          {convo.skills.map(s => (
            <span key={s} className="ch-skill-tag" style={{ "--sc": convo.color }}>{s}</span>
          ))}
        </div>
      </div>

      <div className="ch-right-divider" />

      <div className="ch-detail-label" style={{ marginBottom: 10 }}>Actions</div>
      <button className="ch-action-btn ch-action-primary">
        <Icon.Calendar /> Request Session
      </button>
      <button className="ch-action-btn ch-action-secondary">
        <Icon.Map /> View Roadmap
      </button>
    </div>
  );
}

// ─── MAIN PAGE ────────────────────────────────────────────────────────────────
export default function ChatPage() {
  const [conversations, setConversations] = useState(CONVERSATIONS);
  const [activeId, setActiveId] = useState(1);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("all");
  const [showIssueSelector, setShowIssueSelector] = useState(false);
  const [showTyping, setShowTyping] = useState(false);

  const activeConvo = conversations.find(c => c.id === activeId) || null;

  const handleSelect = id => {
    setActiveId(id);
    setConversations(prev =>
      prev.map(c => c.id === id ? { ...c, unread: 0 } : c)
    );
  };

  const handleNewSupport = () => {
    const adminConvo = conversations.find(c => c.type === "admin");
    if (adminConvo) {
      handleSelect(adminConvo.id);
    } else {
      setShowIssueSelector(true);
    }
  };

  const handleIssueSelect = issue => {
    setShowIssueSelector(false);
    const adminConvo = conversations.find(c => c.type === "admin");
    if (adminConvo) {
      handleSelect(adminConvo.id);
    }
  };

  const handleSend = text => {
    if (!activeConvo) return;

    const newMsg = {
      id: Date.now(),
      from: "student",
      text,
      time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
    };

    setConversations(prev =>
      prev.map(c =>
        c.id === activeId
          ? { ...c, messages: [...c.messages, newMsg], lastMessage: text, time: "Just now" }
          : c
      )
    );

    // Simulate typing + reply
    setShowTyping(true);
    setTimeout(() => {
      setShowTyping(false);
      const replies = {
        mentor: "That's a great point! Let me elaborate on that concept further.",
        admin: "Thank you for the update. Our team is looking into this right away.",
      };
      const reply = {
        id: Date.now() + 1,
        from: activeConvo.type === "admin" ? "admin" : "mentor",
        text: replies[activeConvo.type] || "Thanks for reaching out!",
        time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
      };
      setConversations(prev =>
        prev.map(c =>
          c.id === activeId
            ? { ...c, messages: [...c.messages, newMsg, reply], lastMessage: reply.text, time: "Just now" }
            : c
        )
      );
    }, 1800);
  };

  return (
    <MyStudentLayout>
      <div className="ch-root">
        <LeftPanel
          conversations={conversations}
          activeId={activeId}
          onSelect={handleSelect}
          onNewSupport={handleNewSupport}
          search={search}
          setSearch={setSearch}
          filter={filter}
          setFilter={setFilter}
        />
        <CenterPanel
          convo={activeConvo}
          onSend={handleSend}
          showTyping={showTyping}
        />
        <RightPanel convo={activeConvo} />

        {showIssueSelector && (
          <IssueSelector
            onSelect={handleIssueSelect}
            onClose={() => setShowIssueSelector(false)}
          />
        )}
      </div>
    </MyStudentLayout>
  );
}